/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { object } from 'prop-types';
import { Container } from '@material-ui/core';

const styles = () => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    componentLoader: {
        display: 'flex',
        justifyContent: 'center',
        margin: '40px auto',
    },
    bouncingDot: {
        width: '16px',
        height: '16px',
        margin: '3px 6px',
        borderRadius: '50%',
        backgroundColor: '#a3a1a1',
        opacity: 1,
        animation: '$componentLoader 0.8s infinite alternate',
    },
    '@keyframes componentLoader': {
        to: {
            opacity: 0.1,
            transform: 'translateY(-16px)',
        },
    },
    bouncingDot1: {
        animationDelay: '0.2s',
    },
    bouncingDot2: {
        animationDelay: '0.4s',
    },
    bouncingDot3: {
        animationDelay: '0.6s',
    },

});

const ComponentLoader = ({ classes }) => (
    <Container className={classes.container}>
        <div className={classes.componentLoader}>
            <div className={`${classes.bouncingDot} ${classes.bouncingDot1}`} />
            <div className={`${classes.bouncingDot} ${classes.bouncingDot2}`} />
            <div className={`${classes.bouncingDot} ${classes.bouncingDot3}`} />
        </div>
    </Container>

);

ComponentLoader.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(ComponentLoader);
